import { controllers } from 'chart.js'

if (document.getElementById('anuncie-index')) {
  var appNovoAnuncie = new Vue({
    el: '#anuncie-index',
    data: {
      objForm: {
        nome: '',
        email: '',
        telefone: '',
        'g-recaptcha-response': ''
      },
      enviandoContato: false,
      planoFree: undefined,
      cidadeEscolhida: null
    },
    methods: {
      scrollToPlanos: function () {
        $('html, body').animate(
          {
            scrollTop: $('#planos-anuncie').offset().top
          },
          1000
        )
      },
      enviarContato: function () {
        let _this = this

        _this.enviandoContato = true
        let token = $('input[name="_token"]')
        let _token = ''
        if (document.querySelector('[name="g-recaptcha-response"]')) {
          this.objForm['g-recaptcha-response'] = document.querySelector('[name="g-recaptcha-response"]').value;
        }
        if (token[0]) {
          this.objForm._token = token[0].value
        }

        if (!this.validarEnvioContato()) {
          _this.enviandoContato = false
          return false
        }

        if (!this.validarEmail(_this.objForm.email)) {
          swal({
            title: 'O e-mail informado é inválido!',
            text: 'Confira se você digitou corretamente e tente novamente.',
            type: 'error'
          })
          _this.enviandoContato = false
          $('input[name="email"]').addClass('error')
          return false
        }

        axios
          .post('/fale-conosco.html', this.objForm)
          .then(function (response) {
            _this.enviandoContato = false

            if (response.data.status && response.data.status == 'error') {
              swal({
                title: 'Atenção!',
                text: response.data.message,
                type: 'warning'
              })
            } else if (response.data.status && response.data.status == 'success') {
              swal({
                title: 'Sucesso!',
                text: response.data.message,
                type: 'success'
              })

              _this.objForm.nome = ''
              _this.objForm.email = ''
              _this.objForm.telefone = ''
              _this.objForm.mensagem = ''
            }
          })
          .catch(function (response) {
            swal({
              title: 'Atenção!',
              text: 'Ocorreu um erro, tente novamente mais tarde.',
              type: 'warning'
            })

            _this.enviandoContato = false
          })
      },
      validarEnvioContato: function () {
        var hasError = 0

        $('#formulario-contato-anuncie .campo-validacao-obrigatorio').each(function (index, el) {
          if ($(el).val() == '' && !$(el)[0].hasAttribute('disabled') && $(el).css('display') != 'none') {
            el.classList.add('error')
            hasError = 1
          } else {
            el.classList.remove('error')
          }
        })

        if (hasError) {
          swal({
            title: 'Informe todos os campos obrigatórios!',
            text: 'Confira se você digitou corretamente todos os campos obrigatórios e tente novamente.',
            type: 'error'
          })

          return false
        }

        return true
      },
      validarEmail: function (email) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(email)) {
          return true
        }

        return false
      },
      selectCidadeChange: function (event) {
        let _this = this

        $('#select-cidade-anunciante').on('change', function (e) {
          let cidadeEscolhida = e.target.value
          let arrayCidade = ['blumenau', 'gaspar', 'ilhota', 'indaial', 'pomerode', 'timbo']
          _this.cidadeEscolhida = cidadeEscolhida

          if (arrayCidade.indexOf(cidadeEscolhida) >= 0) {
            _this.planoFree = false
          } else {
            _this.planoFree = false
          }
        })
      }
    },
    mounted() {
      let _this = this
      $(document).ready(function () {
        $('#parceiros-slider').owlCarousel({
          dotsClass: 'nav'
        })

        _this.selectCidadeChange()
      })
    }
  })
}
